import TicketsApi from '@app/api/public/TicketsApi';
import { useQuery } from 'react-query';

export const useGetTicketById = (ticketId: number) =>
    useQuery(['tickets', ticketId.toString(), 'details'], () => TicketsApi.getbyid(ticketId));
